import React, { useEffect, useState } from "react";
import { decodeHtml } from "../../../../assests/extention/commonfunction";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { downloadCV, getCVDetailsById, getSimilarCVList } from "../../../../redux/cv/action";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import downloadFiles from "../../../Common/FilesRelevent/DownloadFiles";
import CVFilterListings from "./CVFilterListings/CVFilterListings";
import Access from "../../../CustomComponents/Access/Access";
import { getDegree } from "../../../../redux/categary/action";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import YearRange from "../../../Common/YearRange";

export default function CVDetails() {
  const path = "Assets/scss/searchdownloadcv.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const { id } = useParams();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formData = useSelector(({ cv: { getcvbyuserid } }) => getcvbyuserid);

  const [totalandsize, setTotalandsize] = useState({
    total: 0,
    size: 0,
  });

  useEffect(() => {
    dispatch(getCVDetailsById(id));
    dispatch(getSimilarCVList(id));
  }, [id]);

  const downloadcvandhitapi = () => {
    if (formData?.downloaded == 1) {
      redownloadcvandhitapi();
    } else {
      const data = { type: "4", user_id: id };
      dispatch(downloadCV(data));
      downloadFiles(formData?.expert?.cv);
    }
    dispatch(getCVDetailsById(id));
  };

  const redownloadcvandhitapi = () => {
    if (formData?.downloaded == 0) {
      setModal(true);
    } else {
      const data = { type: "5", user_id: id };
      dispatch(downloadCV(data));
      downloadFiles(formData?.expert?.cv);
    }
  };

  const cvcc = useSelector(
    ({ cv: { getalreadydownloadedcvlist } }) => getalreadydownloadedcvlist
  );

  const degreelistss = useSelector(
    ({ categary: { degreelist } }) => degreelist
  );

  useEffect(() => {
    dispatch(getDegree());
  }, []);

  const working_days = [
    { id: 0, day: "Sunday" },
    { id: 1, day: "Monday" },
    { id: 2, day: "Tuesday" },
    { id: 3, day: "Wednesday" },
    { id: 4, day: "Thursday" },
    { id: 5, day: "Friday" },
    { id: 6, day: "Saturday" },
  ];

  const formatTimeTo12hr = (time) => {
    const [hour, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hour, minutes);

    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return new Intl.DateTimeFormat("en-US", options).format(date).toLowerCase();
  };

  const StarRating = ({ rating }) => {
    const maxStars = 5;
    return (
      <div className="star-sec">
        {[...Array(maxStars)].map((_, i) => (
          <i
            key={i}
            className={i < rating ? "fa-solid fa-star" : "fa-solid fa-star disabled"}
          ></i>
        ))}
      </div>
    );
  };
  const previousPath = localStorage.getItem("prevCVPage");


  const navtonextpage = () => {
    if (previousPath == 'SearchDownloadCV') {
      navigate(`/${lan}/dashboard/downloads`);
    }
    else {
      const data = {
        industry_id: formData?.industries[0]?.id,
        industry_name: formData?.industries[0]?.title,
        category_id: formData?.categories[0]?.id,
        category_name: formData?.categories[0]?.title,
      };
      navigate(`/${lan}/searchdownloadcvbycategory`, {
        state: { indcatsub: data },
      });
    }

  }

  const flattenSubcategories = (categories) => {
    return categories?.flatMap((category) =>
      category.sub_categories.map((sub) => ({
        ...sub,
        categoryId: category.id,
        categoryTitle: category.title,
      }))
    );
  };

  const subcategoryArray = flattenSubcategories(formData?.categories);


  return (
    <div className="download-details col-lg-11 mx-auto">
      {modal && (
        <Access
          modal={modal}
          setModalOpen={setModalOpen}
          setModal={setModal}
          checkpermission="access_to_cv"
          hitmethod={downloadcvandhitapi}
          masterID={formData?.id}
          checkrole={false}
        />
      )}

      <p className="breadcrumbs">
        <a onClick={() => navtonextpage()}>Back &gt; </a> Profile details
      </p>
      <div className="col-lg-10 mx-auto">
        <div className="download-second">
          <div className="filter-detail">
            <div className="filter-detail-first col-md-7">
              {
                formData?.downloaded == 1 &&
                <ProfileImageWithFallback url={formData?.profile_image} className="profile-img" />
              }
              <div>
                {
                  formData?.downloaded == 1 ?
                    <>
                      <h5>{decodeHtml(formData?.first_name)} {decodeHtml(formData?.last_name)}{" "}</h5>
                      <h6>{decodeHtml(formData?.expert?.designation)}</h6>
                    </>
                    :
                    <></>
                }
                <div className="proposal">
                  {formData && (
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                        alt=""
                      />
                      {formData && formData?.country_title}
                    </p>
                  )}
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                      alt=""
                    />
                    {formData?.expert?.total_experience} years
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                      alt=""
                    />
                    {formData?.expert?.price_per_month}/month
                  </p>
                </div>
              </div>
            </div>
            <button
              className="buttons background-button"
              fdprocessedid="2k0pcs"
              onClick={() => {
                formData?.downloaded == 1
                  ? redownloadcvandhitapi()
                  : setModal(true);
              }}
            >
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/download-1.svg`}
                alt=""
              />
              {formData?.downloaded == 1 ? "Re - Download CV" : "Download CV"}
            </button>
          </div>
          <div className="col-md-11 p-0">
            <div className="download-job">
              <h6>Job title</h6>
              <div className="job-p">
                <p>{decodeHtml(formData?.expert?.designation)}</p>
              </div>
            </div>
            <div className="download-job">
              <h6>About expert</h6>
              <div className="job-p">
                <p>
                  {formData?.expert ? (
                    <CustomReactQuillDescription
                      value={formData?.expert?.about}
                    />
                  ) : (
                    ""
                  )}
                </p>
              </div>
            </div>
            <div className="download-job">
              {Array.isArray(formData?.industries) &&
                <div className="about-expert">
                  <h6 className="pb-3">Industry, Category & Subcategory </h6>
                  <p className="pb-3">
                    <h6>Industry : </h6>
                    {formData?.industries?.map((item, index) => (
                      <>
                        <p key={index}>{item?.title}</p>
                      </>
                    ))}
                  </p>
                  <p className="pb-3">
                    <h6>Category : </h6>
                    {formData?.categories?.map((item, index) => (
                      <>
                        <p key={index}>{item?.title}</p>
                      </>
                    ))}
                  </p>
                  <p className="pb-3">
                    <h6>Subcategory : </h6>
                    {subcategoryArray?.map((item, index) => (
                      <>
                        <p key={index}>{item?.title}</p>
                      </>
                    ))}
                  </p>
                </div>}
            </div>
            <div className="download-job">
              <h6>Known language</h6>
              <div className="job-p">
                {Array.isArray(formData?.language) &&
                  formData?.language?.map((item, index) => (
                    <p key={index}>
                      {item?.language_title} - {item?.proficiency_title}
                    </p>
                  ))}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="download-job">
                  <h6>County</h6>
                  <div className="job-p">
                    <p>{formData?.country_title}</p>
                  </div>
                </div>
              </div>
            </div>
            {formData?.expert && (
              <div className="download-job">
                <h6>Academic info</h6>
                {Array.isArray(formData?.education) &&
                  formData?.education?.map((item, index) => (
                    <div
                      className="job-p"
                      key={index}
                      style={{ rowGap: "0", marginBottom: "10px" }}
                    >
                      <p style={{ paddingBottom: "0px" }}>
                        {Array.isArray(degreelistss) &&
                          degreelistss.filter(
                            (deeg) => deeg.id === item.degree_id
                          )[0]?.title}{" "}
                        - {item?.field}
                      </p>
                      <p style={{ paddingBottom: "0px" }}>{item?.university}</p>
                      <p>
                        {item?.from_year} - {item?.to_year}
                      </p>
                    </div>
                  ))}
              </div>
            )}
            {formData && formData?.education && (
              <div className="download-job">
                <h6>Education</h6>

                {Array.isArray(formData?.education) &&
                  formData?.education?.map((item, index) => (
                    <div
                      className="job-p"
                      key={index}
                      style={{ rowGap: "0", marginBottom: "10px" }}
                    >
                      <p style={{ paddingBottom: "0px" }}>
                        {Array.isArray(degreelistss) &&
                          degreelistss.filter(
                            (deeg) => deeg.id === item.degree_id
                          )[0]?.title}{" "}
                        - {item?.field}
                      </p>
                      <p style={{ paddingBottom: "0px" }}>{item?.university}</p>
                      <p>
                        {item?.from_year} - {item?.to_year}
                      </p>
                    </div>
                  ))}
              </div>
            )}
            {formData && formData?.preferences && (
              <div className="download-job">
                <h6>Working Days</h6>
                <div style={{ display: "flex" }}>
                  {working_days.map(
                    (item, index) =>
                      formData?.preferences?.working_days?.includes(
                        item.id
                      ) && <p key={index}>{item.day},</p>
                  )}
                </div>
              </div>
            )}
            {formData && formData?.working_hours && (
              <div className="download-job">
                <h6>Working Hours</h6>
                <div>
                  {formData.working_hours.map((item, index) => (
                    <p key={index}>
                      {formatTimeTo12hr(item.start_time)} -{" "}
                      {formatTimeTo12hr(item.end_time)}
                    </p>
                  ))}
                </div>
              </div>
            )}
            {formData?.expert && (
              <div className="download-job">
                <h6>Employment </h6>
                <div className="job-p">
                  {Array.isArray(formData?.experience) &&
                    formData?.experience?.map((item, index) => (
                      <>
                        <p>
                          {decodeHtml(item?.designation)} - {item?.company}
                        </p>
                        <YearRange fromYear={item?.from_year} toYear={item?.to_year} />
                      </>
                    ))}
                </div>
              </div>
            )}
            <div className="download-job">
              <h6>Competencies and expertise</h6>
              <div className="add-skills">
                {Array.isArray(formData?.skills) &&
                  formData?.skills?.map((item, index) => (
                    <p>
                      {item?.title}
                    </p>
                  ))}
              </div>
            </div>

            <>
              <div className="download-job">
                <div className="rating-sec">
                  <h6>Rating and Reviews </h6>
                  <div className="overall-rating">
                    <div className="earn-head">
                      <h4>Average rating</h4>
                      <div className="star">
                        <p>
                          <i className="fa-solid fa-star"></i>
                          <span>{formData?.avg_rating}</span>{" "}
                          ({formData?.comment_count}) reviews
                        </p>
                      </div>
                    </div>
                    <div className="review-right">
                      {formData?.rating_category &&
                        formData?.rating_category.map((rat_cat, indi) => {
                          return (
                            <div className="review-star" key={indi}>
                              <p>{rat_cat.title}</p>
                              <StarRating rating={Number(rat_cat.rating)} />
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  {formData?.ratings &&
                    formData?.ratings.map((rating, indi) => {
                      return (
                        <div className="rating-detail" key={indi}>
                          <p>{rating.comment}</p>
                          <h5>
                            {decodeHtml(rating.first_name)} {decodeHtml(rating.last_name)}
                          </h5>
                        </div>
                      );
                    })}
                </div>
              </div>
            </>
          </div>
        </div>
        {cvcc?.experts && <div className="similar-head">
          <h6>Similar candidates</h6>
        </div>}
        {cvcc?.experts && <div className=" bottom-section">
          <CVFilterListings
            expertslist={cvcc?.experts}
            setTotalandsize={setTotalandsize}
          />
        </div>}
      </div>
    </div>
  );
}

// PREEMPTIVE HMR BURST
